"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MODAL_LOADER_KEY", {
  enumerable: true,
  get: function get() {
    return _constants.MODAL_LOADER_KEY;
  }
});
exports.showSelectForSearchCollectionsModal = void 0;
var _loader = _interopRequireDefault(require("../../../../modalDispatcher/loader"));
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var showSelectForSearchCollectionsModal = exports.showSelectForSearchCollectionsModal = (0, _loader.default)({
  key: _constants.MODAL_LOADER_KEY,
  getModal: function getModal() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require(/* select-for-search-collections-moda */"./SelectForSearchCollectionsModal"));
    });
  }
});